import { partialUpdateProposal } from 'common/api/v1/proposals';
import alerts from 'common/modules/alerts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    ARCHIVE_PROPOSAL,
    ARCHIVE_PROPOSAL_FAILURE,
    ARCHIVE_PROPOSAL_SUCCESS,
} from '../actionTypes';
import { proposalsActions } from '../reducer';

import filterProposals from './filterProposals';

export default (filterData, proposalId, value) => (dispatch) => {
    dispatch(proposalsActions[ARCHIVE_PROPOSAL]());
    const newValues = {
        status_flag: value,
    };

    partialUpdateProposal(newValues, proposalId)
        .then((response) => {
            dispatch(proposalsActions[ARCHIVE_PROPOSAL_SUCCESS](response.data));
            dispatch(filterProposals(filterData));
            dispatch(alerts.actions.close());
            showToast();
        })
        .catch((error) => {
            dispatch(
                proposalsActions[ARCHIVE_PROPOSAL_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
